<div>
	@if (value) {
		<div [hidden]="!isListView" [ngClass]="styles.entry" layout="row" flex-align="center" flex-justify="center" flex-wrap="false">
			<div flex>

				@if (value.pushMethod === 'Manual') {
					@if (showToggleBtn) {
						<vb-toggle-button name="enableBannerToggle" [ariaLabel]="'Event_Banner_Toggle' | translate" [(ngModel)]="value.isEnabled" (ngModelChange)="onEnabledToggleClick()">
						</vb-toggle-button>
					} @else {
						<span [ngClass]="styles.bullet">•</span>
					}
				}

				@if (value.pushMethod === 'AtEnd') {
					<span [attr.aria-label]="'Event_Banner_AtEnd' | translate" [ngClass]="[showToggleBtn ? styles.webcastClockIcon : styles.formClockIcon, 'vb-icon vb-icon-center vb-icon-clock']"></span>
				}

			</div>

			<div [ngClass]="styles.bannerName" flex="50">
				<span [ngClass]="styles.bannerNameText">{{ value.name }}</span>
			</div>

			<div [ngClass]="styles.actions" flex="20">
				@if (showEditDeleteBtns) {
					<button class="btn btn-transparent" type="button" [attr.aria-label]="'Edit' | translate" [disabled]="showToggleBtn && value.isEnabled" (click)="onEditClick()">{{ 'Edit' | translate }}</button>
					<button class="btn btn-transparent padding-right-0" type="button" [attr.aria-label]="'Delete' | translate" (click)="onDeleteClick()">{{ 'Delete' | translate }}</button>
				}
				@if (showPreviewBtn && value.link) {
					<button class="btn btn-transparent" type="button" [attr.aria-label]="'Preview' | translate" (click)="onPreviewClick()">{{ 'Preview' | translate }}</button>
				}
			</div>
		</div>
	}
</div>
